module.exports = __webpack_public_path__ + "static/graphicsDesktop@2x-af0d80d2e0605aabd08bdd561570e3e5.png";